import React from "react";
import { Button } from "reactstrap";

export const ButtonTactil = (props) => {
  const valueBoxTactil = props.data;
  const inputValue = props.fieldValue;

  function addNumberToInput() {
    let newValueCi;
    if (props.command === "del") {
      newValueCi = inputValue.substring(0, inputValue.length - 1);
    } else {
      if (props.command === "delAll") {
        newValueCi = "";
      } else {
        newValueCi = inputValue + valueBoxTactil;
      }
    }
    if (newValueCi.length === 10 || newValueCi.length === 13) {
      props.setFlag(false);
    } else {
      props.setFlag(true);
    }
    props.changeFieldValue(newValueCi);
  }

  return (
    <Button
      color="secondary"
      className={props.styleBox}
      onClick={addNumberToInput}>
      {valueBoxTactil}
    </Button>
  );
};
